export default "__VITE_ASSET__fb507b82__"